import { useState , useEffect } from "react";
import { useNavigate , useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";
import RegisterTextbox from "../../components/RegisterTextBox";
import "./MarketingDesignProjectManagement.css";
import RegisterTextarea from "../../components/RegisterTextarea";
import { Form, Spinner } from "react-bootstrap";
import CustomButton from "../../components/CustomButton";
import RegisterRadio from "../../components/Radio";
// import { AppContext } from "../../context/AuthContext";
import UploadInput from "../../components/UploadInput";
import API from "../../api/axiosConfig";
import "react-datepicker/dist/react-datepicker.css";
import RegisterSelect from "../../components/RegisterSelect";
import TestPreLoader from "../TestPreLoader/TestPreLoader";




function EditProjectStatus() {
  
  const [methodtype, setMethodtype] = useState(false);  
  const [total, setTotal] = useState(0);
  const [attachment, setAttachment] = useState('');
  const [error, setError] = useState([]);
  const [methodvalue, setMethodvalue] = useState(0);
  const [marketingmethod, setMarketingmethod] = useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [accounttree, setAccounttree] = useState('');
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

 
  const navigate = useNavigate();

  const getProject = async () => {
    try {
      const response = await API.get(`/projects/${id}`);
      const data = await response;
      setRows(data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setError(error.response.data.errors);
      setMessage(error.response.data.message);
    }
  };

  useEffect(() => {
    getProject(); 
  }, []);


  const handleTotalCostChange = (e) => {
    setRows({...rows , budget : Number(e.target.value)});
  };





  const handelFileChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const mForm = new FormData();
    mForm.append("name", rows.name);
    mForm.append("description", rows.description);
    mForm.append("dateoflaunch", rows.startdate);
    mForm.append("deadline", rows.deadline);
    mForm.append("total", rows.budget);
    mForm.append("marketingmethod", rows.marketingmethod);
    mForm.append("id", id);
    try {
      const res = await API.post("/projects/update", mForm, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const data = await res;
      if (data.status === 200) {
       
          navigate("/projectStatus");

      }
    } catch (error) {
      setIsSubmit(false);
      setError(error.response.data.errors);
    }
  };


  const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";

  // لو أصلاً yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return dateStr;
  }

  // dd-mm-yyyy
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }

  return "";
};
  return (
    loading ? <TestPreLoader /> :<>
      <div className="marketingdesignprojectmanagement">
        <Title
          title=" تعديل إدارة المشاريع"
          className="marketingtitle"
          icon={<FontAwesomeIcon icon={faBullhorn} />}
        />
        <Form
          onSubmit={handleSubmit}
          className="marketingdesignprojectmanagementForm"
          encType="multipart/form-data"
        >
          <div className="marketingdesign">
            <div className="marketInputCon">
              <RegisterTextbox
                parentStyle={{
                  width: "45%",
                }}
                id="name"
                label="إسم المشروع"
                value={rows.name}
                onChange={(e) => setRows({...rows , name : e.target.value})}
                type="text"
                stylee={{
                  width: "55%",
                }}
                name="name"
              />
             
              <RegisterTextbox
                parentStyle={{
                  width: "45%",
                }}
                id="totalCost"
                label="مبلغ الدعم الكلي"
                type="number"
                value={rows.budget}
                onChange={handleTotalCostChange}
                stylee={{
                  width: "55%",
                }}
                name="total"
              />

            </div>
            {error && error.name && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {error.name}
              </div>
            )}

            {error && error.total && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {error.total}
              </div>
            )}

            <div className="marketInputCon">

              <div style={{ display: "flex", justifyContent: "space-between", width: "45%", flexDirection: "column" }}>
                <p>تاريخ البدء</p>
                <input
                  type="date"
                  id="date"
                  onChange={(e) => setRows({...rows , startdate : e.target.value})} //setDateoflaunch(e.target.value)}
                  value={formatDateForInput(rows.startdate)}
                  className="custom-datepicker"
                  style={{ width: "100%" }}

                />
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "45%", flexDirection: "column" }}>
                <p>تاريخ الانتهاء</p>
                <input
                  type="date"
                  id="date"
                  onChange={(e) =>
    setRows((prev) => ({
      ...prev,
      deadline: e.target.value,
    }))
  }
                  value={formatDateForInput(rows.deadline)}
                  className="custom-datepicker"
                  style={{ width: "100%" }}
                />
              </div>
              
            </div>
            <div className="marketInputCon">
              {error && error.dateoflaunch && <span className="error">{error.dateoflaunch}</span>}
              {error && error.deadline && <span className="error">{error.deadline}</span>}
            </div>

            
            <div className="marketInputCon">
           
              <div className="radiodatecon radiodateconMArket">
     
              </div>

            

            </div>
            {error && error.marketingmethod && <span className="error">{error.marketingmethod}</span>}
            <div className="marketInputCon">
            <RegisterSelect
                id="mecanism"
                label="آلية التسويق"
                stylee={{
                  width: "45% !important",
                }}
                parentStyle={{
                  width: "45%",
                  marginBottom: "20px",
                }}
                options={[
                  { value: "0", label: "إختر الآلية" },
                  { value: '1', label: 'المانحون' },
                  { value: "2", label: "المنصات الحكومية" },
                  { value: "3", label: "متاجر الجمعيات" },
                ]}
                value={rows.marketingmethod}
                onChange={(e) => setRows({...rows , marketingmethod : e.target.value})} //setAccounttree(e.target.value)}
              />
            
          
          
            <RegisterTextarea
              label="نبذة عن المشروع"
              stylee={{ width: "100%" }}
              value={rows.description}
              onChange={(e) => setRows({...rows , description : e.target.value})} //setDescription(e.target.value)}
              parentStyle={{
                width: "45%",
                marginBottom: "20px",
              }}
              name="description"
            />
            {error && error.description && <span className="error">{error.description}</span>}
            </div>
           

            {
              isSubmit ? <Spinner animation="border" variant="primary" /> :
                <div className="marketingbuttonCon">
                  <CustomButton text="إنشاء مشروع" />
                </div>}
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditProjectStatus;
